import {
  GET_SESSION_KONSELING_FAIL,
  GET_SESSION_KONSELING_REQUEST,
  GET_SESSION_KONSELING_RESET,
  GET_SESSION_KONSELING_STATUS_FAIL,
  GET_SESSION_KONSELING_STATUS_REQUEST,
  GET_SESSION_KONSELING_STATUS_RESET,
  GET_SESSION_KONSELING_STATUS_SUCCESS,
  GET_SESSION_KONSELING_SUCCESS,
  PDULI_ALERT_TIME_WILL_BE_OVER,
  STOP_SESSION_KONSELING_FAIL,
  STOP_SESSION_KONSELING_REQUEST,
  STOP_SESSION_KONSELING_RESET,
  STOP_SESSION_KONSELING_SUCCESS,
} from "../constants/SessionKonselingConstants";

export const km_get_session_konseling_reducers = (
  state = { data: {} },
  action
) => {
  switch (action.type) {
    case GET_SESSION_KONSELING_REQUEST:
      return { loading: true };
    case GET_SESSION_KONSELING_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case GET_SESSION_KONSELING_FAIL:
      return { loading: false, error: action.payload };
    case GET_SESSION_KONSELING_RESET:
      return {};
    default:
      return state;
  }
};

export const km_get_session_konseling_status_reducers = (
  state = { data: {} },
  action
) => {
  switch (action.type) {
    case GET_SESSION_KONSELING_STATUS_REQUEST:
      return { loading: true };
    case GET_SESSION_KONSELING_STATUS_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case GET_SESSION_KONSELING_STATUS_FAIL:
      return { loading: false, error: action.payload };
    case GET_SESSION_KONSELING_STATUS_RESET:
      return {};
    default:
      return state;
  }
};

export const km_pduli_is_will_time_over_reducers = (
  state = { value: {} },
  action
) => {
  switch (action.type) {
    case PDULI_ALERT_TIME_WILL_BE_OVER:
      return { value: action.payload };
    default:
      return { value: false };
  }
};

export const km_stop_session_konseling_reducers = (
  state = { data: {} },
  action
) => {
  switch (action.type) {
    case STOP_SESSION_KONSELING_REQUEST:
      return { loading: true };
    case STOP_SESSION_KONSELING_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case STOP_SESSION_KONSELING_FAIL:
      return { loading: false, error: action.payload };
    case STOP_SESSION_KONSELING_RESET:
      return {};
    default:
      return state;
  }
};
